module.exports = __webpack_public_path__ + "static/img/products_pageTop_desktop.fe31d30d.jpg";